import React, { useState, useEffect } from 'react';
import Navbar from './global-components/navbar';
import PageHeader from './global-components/page-header';
import FaqSection from './section-components/faq';
import Footer from './global-components/footer';
import { SendMail } from '../request/apiRquest';
import { message } from 'antd';

const Contact = () => {

	message.config({
		top: 100, 
	//	duration: 2, 
	});

	const [maildata, setMailData] = useState({
		FromName: "",
		FromEmail: "",
		ContactNo: "",
		Message: "",
	});

	const handleSubmit = async (e) => {
		e.preventDefault();

		if (!maildata?.ContactNo && !maildata?.FromEmail) {
			message.warning("Please fill the contact details before submitting")
		} else {

			try {
				//console.log(maildata, "submit data");

				//await SendMail(...maildata);
				message.success("Your message has been sent successfully!")
			} catch (error) {
				console.log(error);
				message.error("Failed to send your message. Please try again.");
			}
		}
	}

	const handleChangeInput = (e) => {
		const { name, value } = e.target;

		setMailData({ ...maildata, [name]: value });
	}

	return <div>
		<Navbar />
		<PageHeader headertitle="Contact" />
		<div className="contact-area pd-top-100 pd-bottom-65">
			<div className="container">
				<div className="row">
					<div className="col-lg-12">
						<div className="contact-page-map">
							<iframe className="w-100" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3609.829631009257!2d55.26992347394876!3d25.208967331226575!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6702e02ed9d5d273%3A0xd0b8d09c671ca8c0!2sTRINEST%20SKY%20REAL%20ESTATE!5e0!3m2!1sen!2sin!4v1747805591863!5m2!1sen!2sin" style={{ border: 0 }} allowFullScreen />

						</div>
					</div>
					{/* <div className="col-lg-4"> 
						<form className="contact-form-wrap contact-form-bg">
							<h4>Contact Now</h4>
							<div className="rld-single-input">
								<input type="text" value={maildata.FromName} placeholder="Name" name="FromName" onChange={handleChangeInput} />
							</div>
							<div className="rld-single-input">
								<input type="email" value={maildata.FromEmail} placeholder="Email" name="FromEmail" onChange={handleChangeInput} />
							</div>
							<div className="rld-single-input">
								<input type="number" value={maildata.ContactNo} placeholder="Contact Number" name="ContactNo" onChange={handleChangeInput} />
							</div>
							{/* <div className="rld-single-input">
		            <input type="text" value={maildata.Message} placeholder="Message" name="Message" />
		          </div> */}
							{/* <div className="rld-single-input">
								<textarea rows={10} name="Message" value={maildata.Message} placeholder="Message" onChange={handleChangeInput} defaultValue={""} />
							</div>
							<div className="btn-wrap text-center">
								<button className="btn btn-yellow" type="submit" onClick={handleSubmit}>Submit</button>
							</div>
						</form>
					</div>  */}
				</div>
				<div className="row pd-top-92">
					<div className="col-xl-4 col-sm-6">
						<div className="single-contact-info">
							<p><i className="fa fa-phone" />Call Us:</p>
							<h5>056 860 0147</h5>
						</div>
					</div>
					{/* <div className="col-xl-3 col-sm-6">
		        <div className="single-contact-info">
		          <p><i className="fa fa-fax" />Fax:</p>
		          <h5>(000) 111 222 333</h5>
		        </div>
		      </div> */}
					<div className="col-xl-4 col-sm-6">
						<div className="single-contact-info">
							<p><i className="fa fa-envelope" />Have any Question?</p>
							<h5>info@trinestsky.com</h5>
							<h5>sr@trinestsky.com</h5>
						</div>
					</div>
					<div className="col-xl-4 col-sm-6">
						<div className="single-contact-info">
							<p><i className="fa fa-address-card" />Address</p>
							<h5>Aspin Commercial Tower <br></br>
								- 4302F <br></br>
								-106 Sheikh Zayed Rd <br></br>
								-Trade Centre-Trade Centre 1 <br></br>
								- Dubai</h5>
						</div>
					</div>
				</div>
			</div>
		</div>
		<Footer />
	</div>
}

export default Contact

